import React, { useState } from "react";
import {Modal, Button, Layout, Menu, message, Form, Input, Spin} from 'antd';
import { UserOutlined ,ExportOutlined, UnlockOutlined} from '@ant-design/icons';
import store from "store";
import AxiosUtil from "../utils/AxiosUtil";
import { useHistory } from "react-router"

const { SubMenu } = Menu;

// 创建类型接口
 interface IProps {
    selected?: string[]
}
interface IResPwdParams {
    user_id: number,
    orig_pwd: string,
    new_pwd: string,
    re_pwd: string,
}

const NavHeader = ({ selected }: IProps) => {
    const history = useHistory()
    const [loadingModifyPwd, setLoadingModifyPwd] = useState(false)
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [formResPwd] = Form.useForm();
    const login_info = store.get('login_info')
    if (!login_info || !login_info.access_token) {
        window.location.replace('/#/login');
        return (<></>);
    } else {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const handleOk = () => {
            formResPwd.submit()
        }
        const handleCancel = () => {
            setIsModalVisible(false)
            formResPwd.resetFields()
        }
        const onFinish = (dat: any) => {
            setLoadingModifyPwd(true)
            const {user_id } = store.get('login_info')
            let queryParams: IResPwdParams = {
                user_id: user_id as number,
                orig_pwd: dat.orig_pwd,
                new_pwd: dat.new_pwd,
                re_pwd: dat.re_pwd,
            }
            const callbackResPwd = (suc: boolean, dat: any) => {
                setLoadingModifyPwd(false)
                if (suc) {
                    store.set('login_info', undefined);
                    message.info('密码已重置, 请重新登录')
                    history.push('/login')
                }
            }
            AxiosUtil.AxiosRequest('/authApi/login/changePwd', queryParams, callbackResPwd)
        }
        const login_power = store.get('login_power') || [];

        if (!selected) {
            const hashString = window.location.hash.split('?')[0].split('/');
            login_power.filter((el:any) => {return el.page_url === hashString[0]})
            const selectedIndex = login_power.findIndex((item:any)=> item.page_url === hashString[1])
            if (selectedIndex >= 0) {
                selected = [login_power[selectedIndex].page_url];
                // console.log( hashString,selected);
            }
        }

        const userLogout = () => {
            store.set('login_info', undefined);
            message.success('已退出，请重新登录');
            window.setTimeout(() => {
                window.location.replace('/')
            }, 1000)
        }
        const setPassword = () => {
            setIsModalVisible(true)
        }
        return (
            <Layout.Header className={"main-header"} >
                <div className="logo"></div>
                <Menu className={'main-header-menu flex-blank'} mode="horizontal"
                      defaultSelectedKeys={selected}>
                    {
                        login_power.map((item:any) => {
                            return (
                                <Menu.Item key={item.page_url}>
                                    <a href={'/#/' + item.page_url + '/'}>{item.function_name}</a>
                                </Menu.Item>

                            )
                        })
                    }
                </Menu>
                <Menu className={'main-header-menu'} mode="horizontal">

                    <SubMenu key='login' icon={<UserOutlined/>} title={login_info.login_name}
                             className={'main-header-menu'}>

                        <Menu.Item key='setPassword'>
                            <Button type='link' onClick={setPassword}><UnlockOutlined/> 修改密码</Button>
                        </Menu.Item>
                        <Menu.Item key='userLogout'>
                            <Button type='link' onClick={userLogout}><ExportOutlined/> 退出登录</Button>
                        </Menu.Item>

                    </SubMenu>
                </Menu>
                <Modal title="修改密码" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                    <Spin tip="Loading..." size="large" spinning={loadingModifyPwd}>
                        <Form
                        {...formItemLayout}
                        form={formResPwd}
                        name="resetPwd"
                        onFinish={onFinish}
                        validateTrigger={['onBlur',]}
                    >
                        <Form.Item
                            name="orig_pwd"
                            label="请输入原密码"
                            rules={[
                              { required: true, message: '请输入原密码' },
                            ]}
                            hasFeedback
                        >
                            <Input.Password placeholder="请输入原密码" />
                        </Form.Item>

                        <Form.Item
                            name="new_pwd"
                            label="请输入新密码"
                            rules={[
                                { required: true, message: '请输入新密码' },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('orig_pwd') !== value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('新密码不能和原密码一样!'));
                                  },
                                }),
                            ]}
                            hasFeedback
                        >
                            <Input.Password placeholder="请输入新密码"/>
                        </Form.Item>

                        <Form.Item
                            name="re_pwd"
                            label="请确认新密码"
                            dependencies={['new_pwd']}
                            hasFeedback
                            rules={[
                                { required: true, message: '请确认密码' },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('new_pwd') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('两次输入的密码不匹配!'));
                                  },
                                }),
                            ]}
                        >
                            <Input.Password placeholder="请确认新密码"/>
                        </Form.Item>
                        </Form>
                    </Spin>
                </Modal>
            </Layout.Header>
        );
    }

}


export default NavHeader